import React, {useEffect, useState} from 'react'
import useDidMountEffect from '../../../../../hooks/useDidMountEffect/useDidMountEffect'

import InputSelect from '../../../../../components/modalComponents/InputSelect'
import {Div} from "../../../../registroMaternidad/modales/components/Components";
import {
    getCampanaBeneficioItemsToSolicitarAPI,
} from "../../../../../consumers/backendApisUrls";
import {useManageGetRequest} from "../../../../../hooks/useManageGetRequest/useManageGetRequest";
import {TableCampanasLineamientos} from "../components/StyledComponents";
import {toast} from "react-toastify";
import {useManagePostRequest} from "../../../../../hooks/useManagePostRequest/useManagePostRequest";

const SeleccionarCampana = ({
                                sendCurrentStep,
                                setSendCurrentStep,
                                componentStep,
                                KEYS,
                                selectProps,
                                SECTION_NAME,
                                formValues,
                                modalData,
                                setModalData,
                                getPayloadToGetItems,
                                setAceptoTerminosCondiciones,
                                aceptoTerminosCondiciones,
                                isLoading,
                                setIsLoading
                            }) => {
    const [executeManagePost] = useManagePostRequest();
    // const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [mostrarMensajeValidacion, setMostrarMensajeValidacion] = useState(false);

    useDidMountEffect(() => {
        if (sendCurrentStep?.step === componentStep && sendCurrentStep?.isSent) {
            handleSubmit();
        }
    }, [sendCurrentStep])

    useDidMountEffect(() => {
        try {
            setIsLoading(true);
            // if (isInitialLoad) {
            //     setIsInitialLoad(false);
            //     return;
            // }
            getCampanaBeneficioItemsToSolicitar();
        } catch (error) {
            console.error(error);
        }finally{
            setIsLoading(false);
        }
    }, [formValues[KEYS.idCampanaBeneficio]])

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        if (aceptoTerminosCondiciones === true) {
            setSendCurrentStep(lastData => ({...lastData, isSent: false, isSaved: true}));
            setMostrarMensajeValidacion(false);
        } else {
            setMostrarMensajeValidacion(true);
            toast.error("Necesitamos que aceptes los términos antes de continuar.")
        }
    }

    async function getCampanaBeneficioItemsToSolicitar() {
        try {
            const api = getCampanaBeneficioItemsToSolicitarAPI();
            const payload = getPayloadToGetItems();
            await executeManagePost(api, payload, (res) => successCallbackGetCampanaBeneficioItemsToSolicitar(res), false, null, true);
        } catch (error) {
            console.error(error)
        }
    }

    const successCallbackGetCampanaBeneficioItemsToSolicitar = (res) => {


        const rows = res?.data?.CampanaBeneficioItems.map(item => ({
            ...item, checked: false, cantidad: 0
        }));
        
        setModalData({...modalData, campanaBeneficioItemsToSolicitarResponse: res?.data, currentItems: rows});

    }

    const handleCheckboxChange = (e) => {
        setAceptoTerminosCondiciones(e.target.checked);
    };

    const nombresMeses = (mes , number) =>{
        const fecha = new Date(mes);
        if(number)
        { 
            fecha.setMonth(fecha.getMonth() + 1);
        }
        const nombreMes = fecha.toLocaleString('es-PE', { month: 'long' });
        return nombreMes;
    }
    const getDia = (mes) =>{
        const fecha = new Date(mes);
        const dia = fecha.getDate();
        return dia;
    }
    const getFechasInicioFin = (fInicio, fFin) => {
        const fechaInicio = new Date(fInicio);
        const fechaFin = new Date(fFin);
        const vigenciaCampana= getDia(fechaInicio)+ " de " + nombresMeses(fechaInicio) +" al " + getDia(fechaFin) + " de " + nombresMeses(fechaFin);
        return vigenciaCampana
    }
    const getNombreMinuscula = (texto) => {
        return texto.split(" ")[0].toLowerCase();
    }
    
    return (
        <>
            <div className="displayFlexWrap">
                <Div>
                    <InputSelect
                        label="Campaña"
                        {...selectProps(KEYS.idCampanaBeneficio)}
                        sectionName={SECTION_NAME}
                        isDisabled={false}
                        isRequired={true}
                        hasValidationMessage={false}
                        placeholder={"Seleccionar Campaña"}
                    />
                </Div>

            </div>

            {modalData?.campanaBeneficioItemsToSolicitarResponse?.LineamientosUrl &&
                <>
                    <div className="mt-3 d-flex justify-content-between">
                        <div>
                            <p>Revisa los lineamientos <a
                                href={modalData?.campanaBeneficioItemsToSolicitarResponse?.LineamientosUrl}
                                target="_blank">AQUÍ</a></p>
                        </div>
                    </div>

                    <div>
                        <ul>
                            <li>
                                <p>
                                    <strong>
                                        Campaña vigente del <strong>{getFechasInicioFin(modalData?.campanaBeneficioItemsToSolicitarResponse?.FechaInicio,modalData?.campanaBeneficioItemsToSolicitarResponse?.FechaFin)}</strong>
                                    </strong>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Se puede realizar la compra de más de un(a) {getNombreMinuscula(modalData?.campanaBeneficioItemsToSolicitarResponse?.NombreCampana)}, siempre y cuando no superen el monto total según el puesto.
                                </p>
                            </li>
                            <li>
                                <p>
                                    El monto total del pedido será descontado en un máximo de <strong>{modalData?.campanaBeneficioItemsToSolicitarResponse?.CuotasMax} cuotas</strong> en la planilla de <strong> {modalData?.campanaBeneficioItemsToSolicitarResponse?.MesesMaximoCuotas}</strong>.
                                </p>
                            </li>
                        </ul>
                        <TableCampanasLineamientos>
                            <table>
                                <thead>
                                <tr>
                                    <th>Solicita tu pedido desde:</th>
                                    <th>Recepciona tu pedido:</th>
                                    <th>Vigencia del pedido:</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Del {getFechasInicioFin(modalData?.campanaBeneficioItemsToSolicitarResponse?.FechaInicio,modalData?.campanaBeneficioItemsToSolicitarResponse?.FechaFin)}</td>
                                    <td>{modalData?.campanaBeneficioItemsToSolicitarResponse?.FechaEnvio}</td>
                                    <td>{modalData?.campanaBeneficioItemsToSolicitarResponse?.VigenciaPedido}</td>
                                </tr>
                                </tbody>
                            </table>
                        </TableCampanasLineamientos>
                    </div>
                    <div>
                        <label>
                            <input
                                type="checkbox"
                                checked={aceptoTerminosCondiciones}
                                onChange={handleCheckboxChange}
                            />
                            &nbsp;Doy conformidad de haber leído los lineamientos y cronogramas de la campaña.
                        </label>
                        {!aceptoTerminosCondiciones &&
                            <p className="ficha-form-input-validation-message">Necesitamos que aceptes los términos
                                antes de continuar</p>
                        }
                    </div>
                </>
            }

        </>
    )
}

export default SeleccionarCampana;